import * as Config from '../config';
import { useContext } from "react";
import { ReactReduxContext } from 'react-redux';
import { useHistory } from "react-router-dom";

import useGetFromApi from './useGetFromApi';
import { setSelectedItems, openDrawer } from "../actions/index";

const useReleases = (id, pathApi, perPage = 100, type = 'RELEASE') => {
  const [response] = useGetFromApi(id, pathApi, perPage);
  const { store } = useContext(ReactReduxContext);
  const { dispatch } = store;
  const state = store.getState();
  let result = (response) ? { ...response } : null;
  let globalHistory = useHistory();

  const beginDrag = (id) => {
    return () => {
      dispatch(openDrawer());
      state.api.getFromApi(`/catalog/releases/${id}/tracks/?per_page=100`, false).then( response => {
        dispatch(setSelectedItems([...response.data.results.map(Config.formattedFromBP)]));
      } ).catch( e => console.log(`error`, e) );
    }
  }

  const resizeImg = (url) => url.replace(`500x500`, `200x200`).replace(`1400x1400`, `200x200`);

  const format = x => ({
    id: x.id,
    title: x.name,
    name: x.name,
    artists: x.artists,
    artists_s: x.artists.map(artist => artist.name).join(', '),
    img: (x.image && x.image.uri !== Config.DEFAULT_IMG) ? resizeImg(x.image.uri) : ( (x.person && x.person.owner_image) ? resizeImg(x.person.owner_image) : Config.DEFAULT_IMG),
    images: [(x.image && x.image.uri !== Config.DEFAULT_IMG) ? resizeImg(x.image.uri) : ( (x.person && x.person.owner_image) ? resizeImg(x.person.owner_image) : Config.DEFAULT_IMG)],
    audio: { //USED BY THE SOURCE D&D
      id: x.id,
      name: x.name,
      tracks: x.track_count,
      uri: `/releases/${x.id}`,
      parentPathApi: pathApi,
      artists_s: x.artists.map(artist => artist.name).join(', '),
      ref: `${x.id}|${id}`
    },
    tracks: x.track_count,
    label: x.label.name,
    type,
    dragEnabled: true,
    playEnabled: false,
    beginDrag: beginDrag(x.id),
    isActive: (globalHistory.location.pathname === `/releases/${x.id}`),
    isExplicit: (x.is_explicit) ? x.is_explicit : false,
    tag: (x.pre_order) ? 'Pre-order' : null /*(!x.is_available_for_streaming ? `Preview` : null )*/
  });

  if (response) {
    result.items = (response.items) ? response.items.map(format) : null;
  }

  return [result];
};

export default useReleases;
